import { render, staticRenderFns } from "./problemEdit.vue?vue&type=template&id=269438b7&scoped=true&"
import script from "./problemEdit.vue?vue&type=script&lang=js&"
export * from "./problemEdit.vue?vue&type=script&lang=js&"
import style0 from "./problemEdit.vue?vue&type=style&index=0&id=269438b7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269438b7",
  null
  
)

export default component.exports